import General from './General';

const Layout = ({ layout, ...props }) => {
  switch (layout) {
    default:
      return <General {...props} />;
  }
};

export default Layout;
